module.exports = __webpack_public_path__ + "static/csdb-logo-730e005883a557148b8378cb09e7d510.svg";